import script from "./MaterialCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialCheck.vue?vue&type=script&setup=true&lang=js"

import "./MaterialCheck.vue?vue&type=style&index=0&id=c7241202&lang=less&scoped=true"
import "./MaterialCheck.vue?vue&type=style&index=1&id=c7241202&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7241202"]])

export default __exports__